import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PublicKbError } from '../../components/public-kb/PublicKbError'
import { PublicKbShell } from '../../components/public-kb/PublicKbShell'
import { getPublicWorkspace } from '../../lib/public-kb-api'
import { isPublicKbHost } from '../../lib/public-kb-host'

export const Route = createFileRoute('/knowledge')({
  beforeLoad: async () => {
    if (!isPublicKbHost()) {
      return { publicKb: false as const }
    }

    const result = await getPublicWorkspace()
    if (!result.success) {
      return {
        publicKb: true as const,
        publicWorkspace: null,
        publicKbError: result.error,
      }
    }

    return {
      publicKb: true as const,
      publicWorkspace: result.data,
      publicKbError: null,
    }
  },
  component: KnowledgeBranchLayout,
})

function KnowledgeBranchLayout() {
  const context = Route.useRouteContext()

  if (!context.publicKb) {
    return <Outlet />
  }

  if (context.publicKbError || !context.publicWorkspace) {
    const isPlanLimit = context.publicKbError?.code === 'PLAN_LIMIT_REACHED'
    return (
      <div className="min-h-screen bg-white">
        <PublicKbError
          title={isPlanLimit ? 'Plan upgrade required' : 'Help center not found'}
          message={
            context.publicKbError?.message ??
            'This knowledge base is not available at this address.'
          }
        />
      </div>
    )
  }

  return (
    <PublicKbShell workspace={context.publicWorkspace}>
      <Outlet />
    </PublicKbShell>
  )
}
